import request from '@/utils/request'
// 获取工单列表 待处理or处理
export function workOrder(status, name, page, searchType) {
  return request({
    url: '/health-doctor-assistant/workOrder/workbench/list',
    method: 'post',
    data: {
      orderStatus: status,
      searchName: name,
      pageNo: page,
      pageSize: 10,
      searchType
    }
  })
}
// 获取工单处理条数
export function workOrderCount(name) {
  return request({
    url: '/health-doctor-assistant/workOrder/workbench/count',
    method: 'post',
    data: {
      searchName: name
    }
  })
}
// 获取工单处理条数
export function oneWorkOrder(workOrderId, status = 3) {
  return request({
    url: '/health-doctor-assistant/workOrder/workbench/get',
    method: 'post',
    data: {
      workOrderId,
      orderStatus: status
    }
  })
}
// 获取工单信息的详细信息 handleFlag 是否修改工单状态
export function handleWorkOrder(workOrderId, handleFlag = false) {
  return request({
    url: '/health-doctor-assistant/workOrder/handle',
    method: 'post',
    data: {
      workOrderId,
      handleFlag
    }
  })
}

export function queryGroupMemberse(data) {
  return request({
    url: '/health-doctor-assistant/workOrder/queryGroupMembers',
    method: 'post',
    data
  })
}
// 待处理/处理中工单数量
export function queryAllWorkOrderCount(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/pending-work-order/queryCount',
    method: 'get',
    params: data
  })
}
// 查询待处理工单列表
export function queryPendingWorkOrder(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/v2/queryPendingWorkOrderList',
    method: 'post',
    data: data
  })
}
// 查询处理中工单列表
export function queryProcessingWorkOrder(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/v2/queryProcessingWorkOrderList',
    method: 'post',
    data: data
  })
}
// 查询工单群组信息
export function getGroupInfo(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/v2/getGroupInfo',
    method: 'post',
    params: data
  })
}
// 工单处理
export function handleOrder(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/v2/handle',
    method: 'post',
    data: data
  })
}
// 查询当前工单状态
export function getStateByWorkOrderId(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/getStateByWorkOrderId',
    method: 'get',
    params: data
  })
}
// 根据用户信息查询当前健管是否存在处理中的工单
export function haveProcessingOrder(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/getIsHaveDoingWorkOrderByUserId',
    method: 'post',
    data: data
  })
}
// 根据用户信息查询当前健管处理中的工单id数组，与是否存在接口规则一致；无工单时 data 为空数组
export function getDoingWorkOrderIdByUserId(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/getDoingWorkOrderIdByUserId',
    method: 'post',
    data: data
  })
}

// 开启全病程确认
export function joinCourseServices(data) {
  return request({
    url: '/health-patient/patient/joinCourseServices',
    method: 'post',
    data: data
  })
}
// 领取工单
export function receiveWorkOrder(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/getOneWorkOrder',
    method: 'post',
    data: data
  })
}
// 挂起工单
export function hungupOrder(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/suspend',
    method: 'post',
    data: data
  })
}
//创建bd工单
export function pushBdOrder(data) {
  return request({
    url: '/health-doctor-assistant/doctor/register/send-to-bd',
    method: 'post',
    data: data
  })
}
// 查询子集代办的
export function subTaskPopWindow(data) {
  return request({
    url: 'health-doctor-assistant/workOrderCenter/subTaskPopWindow',
    method: 'get',
    params: data
  })
}

// 处理工单前校验
export function beforeHandleOrder(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/v2/handle/checkRollbackBeforeHandle',
    method: 'post',
    data
  })
}

// 查询工单回滚信息
export function apiWorkOrderRollbackInfo(data) {
  return request({
    url: '/health-doctor-assistant/workOrder/queryWorkOrderRollbackInfo',
    method: 'get',
    params: data
  })
}

// 自动回滚工单
export function apiAutoRollbackWorkOrder(data) {
  return request({
    url: '/health-doctor-assistant/workOrder/autoRollbackWorkOrder',
    method: 'post',
    data
  })
}

// 查询关联工单
export function apiQueryRelationWorkOrder(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/queryRelationWorkOrder',
    method: 'get',
    params: data
  })
}

// 查询处理痕迹
export function apiQueryHandleTrace(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/listWorkOrderProcessTrace',
    method: 'get',
    params: data
  })
}

// 查询绩效指标
export function apiGetPerformanceIndicators(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/getPerformanceIndicators',
    method: 'get',
    params: data
  })
}

// 自动回滚工单
export function messageTraceIds(data) {
  return request({
    url: 'health-doctor-assistant/sms-info/list-by-ids',
    method: 'post',
    data
  })
}

// 查询关联工单
export function doctorAssistantSubmitFeedback(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/doctorAssistantSubmitFeedback',
    method: 'post',
    data
  })
}

// 健管进入导诊群调用获取导诊推荐信息
export function guideRecommendedInfo(data) {
  return request({
    url: `/health-doctor-assistant/workOrder/guideRecommendedInfo?workOrderId=${data.workOrderId}`,
    method: 'post'
  })
}

// 更新患者导诊小结弹窗信息
export function updateGuideInformFlag(data) {
  return request({
    url: `/health-doctor-assistant/workOrder/updateGuideInformFlag?workOrderId=${data.workOrderId}`,
    method: 'post'
  })
}

export function getDoctorDetailById(data) {
  return request({
    url: `/health-doctor/user/detail`,
    method: 'get',
    params: data
  })
}

export function getAssDetailById(data) {
  return request({
    url: `/health-assistant/home/page/queryBdInfo`,
    method: 'get',
    params: data
  })
}

export function followResultEnumList(data) {
  return request({
    url: `/health-doctor-assistant/requireFollow/work/followResultEnumList`,
    method: 'get',
    params: data
  })
}

export function submitFollowRecord(data) {
  return request({
    url: `/health-doctor-assistant/requireFollow/work/submitFollowRecord`,
    method: 'post',
    data
  })
}

// 进度跟踪
export function requireFollowList(data) {
  return request({
    url: `/health-doctor-assistant/requireFollow/work/requireFollowList`,
    method: 'get',
    params: data
  })
}

export function getPatientDiseaseForRequire(data) {
  return request({
    url: `/health-doctor-assistant/requireFollow/work/getPatientDiseaseForRequire`,
    method: 'get',
    params: data
  })
}

// 获取就诊人备注列表
export function getPatientProfileList(data) {
  return request({
    url: `/health-patient/patientProfile/list/da`,
    method: 'post',
    data
  })
}

// 查询业务关联就诊人列表
export function getListBusinessPatientProfile(data) {
  return request({
    url: `/health-patient/patientProfile/listBusinessPatientProfile`,
    method: 'post',
    data
  })
}
// 查询诊人列表
export function getProfileList(data) {
  return request({
    url: `/health-patient/patientProfile/list`,
    method: 'post',
    data
  })
}
// 获取IM会话当前问诊详情
export function getConsultDetail(data) {
  return request({
    url: `/health-cure/cure/consult/detail`,
    method: 'get',
    params: data
  })
}
// 通话小结待办分页查询通话小结
export function getPageCallAiChatSummary(data) {
  return request({
    url: `/health-im/im/chat-summary/pageCallAiChatSummary`,
    method: 'post',
    data
  })
}
